var _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureVolumeTorus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.27748e-18,0.11885,-0.0753829,4.61587e-18,137.646,20.1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.222,105.775L41.222,121.324L15.98,101.425L41.222,81.527L41.222,97.075L167.431,97.075L167.431,81.527L167.431,121.324L167.431,105.775L41.222,105.775Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.333994,0.475459,-0.205615,0.144438,93.4335,15.7436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.191,105.775L33.191,121.324L15.98,101.425L33.191,81.527L33.191,97.075L167.431,97.075L167.431,81.527L167.431,121.324L167.431,105.775L33.191,105.775Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.29723e-17,0.462224,-0.251277,1.77219e-17,154.986,32.6136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.98,105.775L15.98,97.075L167.431,97.075L167.431,81.527L167.431,121.324L167.431,105.775L15.98,105.775Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.462224,7.12754e-17,-3.31082e-17,-0.251277,207.386,135.486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.98,105.775L15.98,97.075L167.431,97.075L167.431,81.527L167.431,121.324L167.431,105.775L15.98,105.775Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,74.9063,54.5051)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.3,
    y: 22.405,
    width: 11.031,
    height: 18.087,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'Helvetica-Bold', 'Helvetica'",
      fontWeight: 700,
      fontSize: "18.087px",
      fill: "rgb(24,25,26)"
    }
  }, "\u03B8")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-1.57817,30.8519)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "R")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,68.3234,-3.07439)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "r")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-21.211,83.7606)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "V")), /*#__PURE__*/React.createElement("path", {
    d: "M219.997,110L220,110C220,159.706 179.706,200 130,200C80.328,200 40,159.672 40,110C40,60.294 80.294,20 130,20L130.065,20C135.554,20.072 140,29.328 140,40.719C140,52.154 135.519,61.438 130,61.438C103.18,61.438 81.438,83.18 81.438,110C81.438,128.111 91.373,143.919 106.086,152.268C113.147,156.274 121.309,158.562 130,158.562C156.82,158.562 178.562,136.82 178.562,110C178.562,104.481 187.846,100 199.28,100C210.714,100 219.997,104.481 219.997,110Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,1,-140,0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135,
    cy: 40.719,
    rx: 5,
    ry: 20.719,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.63px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.13292,0,0,0.482653,-358.665,90.3469)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135,
    cy: 40.719,
    rx: 5,
    ry: 20.719,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.34px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,257.814,220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.814,110C101.814,124.687 113.72,136.593 128.407,136.593L128.407,110L101.814,110Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureVolumeTorus);
export default __webpack_public_path__ + "static/media/calc-figure-volume-torus.9684547a32daba79f08e9616d25a8a6b.svg";
export { ForwardRef as ReactComponent };